import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, } from 'react';
import { useDispatch } from 'react-redux';
import useRouter, { PhenotypeViewRoute, } from 'Router/index';
import { useValidatedPhenotypeId } from 'PhenotypeView/hooks';
import { cleanup } from 'PhenotypeView/store/slice';
import { ECleanup } from 'PhenotypeView/store/types';
import PhenotypeViewTabs from './PhenotypeViewTabs';
const PhenotypeViewTabsContainer = ({ children, }) => {
    const dispatch = useDispatch();
    const { navigateTo, getParams, } = useRouter();
    const { encodedPhenotypeName, datasetVersionId, levelResult, } = getParams();
    const phenotypeId = useValidatedPhenotypeId();
    const handleNavigation = useCallback((selectedLevelResult) => {
        if (levelResult !== selectedLevelResult) {
            dispatch(cleanup(ECleanup.Phenotype));
        }
        navigateTo(PhenotypeViewRoute, {
            phenotypeId,
            encodedPhenotypeName,
            datasetVersionId,
            levelResult: selectedLevelResult,
        }, undefined, { phenotypeId });
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, [navigateTo, datasetVersionId, phenotypeId, dispatch, levelResult, encodedPhenotypeName]);
    return (_jsx(PhenotypeViewTabs, Object.assign({ activeTab: levelResult, onTabsNavigation: handleNavigation }, { children: children }), void 0));
};
export default memo(PhenotypeViewTabsContainer);
